import moment from "moment";
import { Badge } from "../../components/badge";
import { TaskBadgesProps } from "./Task.types";
import { TaskStatuses } from "../../entities/ITask";

const TaskBadges = ({ task }: TaskBadgesProps) => {
  return (
    <div className="flex-row gap-1 flex-wrap">
      <Badge variant="outlined" type="primary" className="fs-6 fw-normal">
        Basket: {task.basket.name}
      </Badge>
      {task.status !== TaskStatuses.RESOLVED &&
        task.status !== TaskStatuses.CANCELED &&
        task.assignee && (
          <Badge variant="outlined" type="info" className="fs-6 fw-normal">
            Assigned to {task.assignee.name}
          </Badge>
        )}
      <Badge variant="outlined" type="dark" className="fs-6 fw-normal">
        Created by {task.createdBy.name}
      </Badge>
      <Badge variant="outlined" type="secondary" className="fs-6 fw-normal">
        Created at {moment(task.createdAt).format("DD.MM.YYYY")}
      </Badge>
    </div>
  );
};

export default TaskBadges;
